export default {
    nav: {
        brand: 'travellingdominika',
        services: 'Leistungen',
        portfolio: 'Portfolio',
        contact: 'Kontakt',
    },
    hero: {
        taglineLabel: 'HIER',
        taglineTitle: 'Dominika',
        taglineSubLine1: 'Content Creator,',
        taglineSubLine2: 'die Aufmerksamkeit weckt.',
        socialsLabel: 'LERN MICH KENNEN',
    },
    intro: {
        label: 'ÜBER MICH',
        greet: 'Hallo / hi!',
        title: 'Hier ist Dominika.',
        body1: 'Ich gestalte kreativen Content, reise um die Welt, finde Ruhe in der Natur und fange schöne Momente durch die Linse meiner Kamera ein.',
        body2: 'Inspiration finde ich in neuen Erfahrungen, schönen Orten, Bergen und interessanten Menschen.',
        expandCta: 'Lern mich besser kennen',
        collapseCta: 'Schliessen',
        longBioLabel: 'DIE LÄNGERE GESCHICHTE',
        instagramTitle: 'Neuester Instagram-Beitrag',
        longBio: [
            'Mein Name ist Dominika. Inspirieren lassen ich mich von häufigen Reisen, neuen Orten, schönen Interieurs, der Natur und der Kulinarik.',
            'Von Beruf bin ich Radiologietechnologin, doch aus Leidenschaft für kreatives Schaffen wurde ich Content Creator und Social Media Managerin. Ich habe über 6 Jahre Erfahrung im Marketing und in den sozialen Medien.',
            'Tagsüber arbeite ich in einer Agentur für Medizinmarketing als Social Media Specialist und betreue Kund:innen und Marken bei der Entwicklung ihrer Social Media oder mit kreativem Content.',
            'Mein liebster Teil der Arbeit: kreative Materialien für Tourismus-, Reise- und Hotelmarken zu schaffen. Diese Arbeit erfüllt mich mit positiver Energie, ich liebe es, schöne Momente einzufangen, mit Licht zu spielen und mit der Kamera Geschichten, Emotionen und Atmosphäre festzuhalten.',
            'An jedes Projekt gehe ich ganzheitlich heran, ich erstelle eine Mood Map und suche nach Ideen, damit die Botschaft authentisch wirkt.',
            'Neue Orte zu entdecken ist meine grosse Leidenschaft, deshalb ist jede Reise für mich ein inspirierendes Abenteuer.',
            'Ich liebe die Natur in der Schweiz, das italienische la dolce vita, habe mich in die japanische Kultur verliebt und schätze die Kulinarik und Lokalität Polens.',
            'An meiner Arbeit schätze ich, dass jeder Tag eine neue Seite aufschlägt, die mich kreativ herausfordert.',
        ],
    },
    services: {
        label: 'LEISTUNGEN',
        headlinePre: 'Zwei Wege,',
        headlineItalic: 'wie wir',
        headlinePost: 'zusammenarbeiten können.',
        ugc: {
            tag: 'Content creation.',
            titlePre: 'Content',
            titleItalic: 'mit',
            titlePost: 'Idee.',
            intro: 'Zeig mir, was deinen Ort besonders macht, und ich fange diese Magie durch die Linse ein.',
            body: 'Ich gestalte Content für Hotels, Städte, Tourismusregionen, lokale Unternehmen, Restaurants, Cafés und Produktmarken.',
            stat: '60+',
            statLabel: 'zufriedene Kund:innen',
        },
        manage: {
            tag: 'Social Media Management.',
            titlePre: 'Ich führe',
            titleItalic: 'den ganzen',
            titlePost: 'Feed.',
            intro: 'Erzähl mir, was dein Business braucht, und ich übernehme deine Social Media von A bis Z.',
            body: 'Ich betreue deine Profile auf Instagram, Facebook, LinkedIn oder TikTok, ganzheitlich.',
            stat: '6+ Jahre',
            statLabel: 'Erfahrung im Social Media Management',
        },
    },
    pricing: {
        label: 'PAKETE',
        title: 'Beispielpakete.',
        sub: 'Preise individuell, ich erstelle dir gerne ein massgeschneidertes Angebot.',
        currency: 'CHF',
        from: 'Ab',
        items: [
            {
                name: 'Fotografie',
                price: '600',
                bullets: [
                    'Paket von 10–50 Fotos (Anzahl nach Absprache) in hoher Qualität nach Bearbeitung',
                    'Die Bilder dürfen frei für deine Zwecke genutzt werden',
                ],
            },
            {
                name: 'Instagram Foto',
                price: '1200',
                bullets: [
                    'Kreative Carousel-Posts mit 5–15 Bildern (Anzahl nach Absprache)',
                    '1 Reel oder 1 Paket à 10 Fotos in hoher Qualität nach Bearbeitung',
                ],
            },
            {
                name: 'Instagram Video',
                price: '800',
                bullets: [
                    'Reel von 30–45 Sekunden (Anzahl Reels nach Absprache)',
                ],
            },
            {
                name: 'Foto × Travellingdominika',
                price: '600',
                bullets: [
                    "Kreatives Carousel mit 5–15 Bildern, in Co-Creation mit meinem Account {'@'}travellingdominika",
                ],
            },
        ],
        footer: 'Jedes Angebot ist individuell. Ich bin offen für Gespräche und Verhandlungen, schreib mir, und wir finden zusammen die passende Lösung.',
    },
    realizations: {
        label: 'MEINE PROJEKTE',
        titlePre: 'Ich gestalte Content, der',
        titleItalic: 'Geschichten erzählt',
        titlePost: 'und Menschen bewegt.',
        body: 'An meiner Arbeit liebe ich, dass jeder Tag eine neue Seite aufschlägt, die mich kreativ herausfordert.',
        list: [
            { icon: 'camera', label: 'Fotografie' },
            { icon: 'film', label: 'Kurzvideos' },
            { icon: 'pen', label: 'Kreative Texte' },
            { icon: 'pin', label: 'Press Trips & Storytelling rund um den Ort' },
            { icon: 'share', label: 'Social Media Management' },
        ],
        cards: [
            { title: 'Hotels' },
            { title: 'Tourismus & Reisen' },
            { title: 'Kulinarik & Restaurants' },
            { title: 'Lokale Unternehmen' },
            { title: 'Produktfotografie' },
            { title: 'Mode' },
            { title: 'Outdoor' },
        ],
        prev: 'Zurück',
        next: 'Weiter',
    },
    stats: {
        label: 'IN ZAHLEN',
        title: 'Ein paar Jahre im Spiel mit dem Licht.',
        sub: 'Mir geht es nicht in erster Linie um Zahlen, sondern um qualitativen, fesselnden Content, hier siehst du dennoch ein bisschen mehr von meiner Erfahrung.',
        items: [
            { value: '6+', label: 'Jahre Erfahrung', sub: 'in Content Creation und Social Media' },
            { value: '60+', label: 'Partnerschaften', sub: 'Kund:innen, Marken und Kollaborationen' },
            { value: '1 Mio+', label: 'Reichweite', sub: "rund um {'@'}travellingdominika" },
            { value: '30+', label: 'Länder', sub: 'aus denen ich Inspiration mitgebracht habe' },
        ],
    },
    portfolio: {
        label: 'PORTFOLIO',
        title: 'Orte, an denen ich war.',
        hint: 'ziehen',
        galleryCta: 'Ganze Galerie ansehen',
        items: [
            { title: 'Kyoto', place: 'Japan' },
            { title: 'Bieszczady', place: 'Polen' },
            { title: 'Harder Kulm', place: 'Schweiz' },
            { title: 'Grindelwald First', place: 'Schweiz' },
            { title: 'Gdańsk', place: 'Polen' },
            { title: 'Luzern', place: 'Schweiz' },
            { title: 'Como', place: 'Italien' },
            { title: 'Kopenhagen', place: 'Dänemark' },
            { title: 'Bern', place: 'Schweiz' },
        ],
        closeLabel: 'Schliessen',
        prevLabel: 'Vorheriges Foto',
        nextLabel: 'Nächstes Foto',
        photoCount: 'Fotos',
        backLabel: 'Zurück',
        categoryTaglines: {
            hotels: "Hotels, mit denen ich zusammengearbeitet habe",
            tourism: "Orte, an denen ich war",
            products: "Marken & Produkte, die ich fotografiert habe",
        },
        categoryLabels: {
            hotels: 'Hotels',
            tourism: 'Tourismus',
            products: 'Produktshootings',
        },
        filterLabel: 'Zeigen',
        filterAll: 'Alle',
        albums: [
            {
                title: "Filario",
                place: "Comer See, Italien",
                category: "hotels",
                description: "Ein Design-Hotel am Comer See — Licht direkt am Wasser, ruhige Interieurs und weite Blicke über den See.",
                cover: '/portfolio/filario/1.jpg',
                photos: [
                    '/portfolio/filario/1.jpg',
                    '/portfolio/filario/2.jpg',
                    '/portfolio/filario/3.jpg',
                    '/portfolio/filario/4.jpg',
                    '/portfolio/filario/5.jpg',
                    '/portfolio/filario/6.jpg',
                    '/portfolio/filario/7.jpg',
                    '/portfolio/filario/8.jpg',
                    '/portfolio/filario/9.jpg',
                    '/portfolio/filario/10.jpg',
                    '/portfolio/filario/11.jpg',
                    '/portfolio/filario/12.jpg',
                    '/portfolio/filario/13.jpg',
                    '/portfolio/filario/14.jpg',
                    '/portfolio/filario/15.jpg',
                    '/portfolio/filario/16.jpg',
                    '/portfolio/filario/17.jpg',
                    '/portfolio/filario/18.jpg',
                    '/portfolio/filario/19.jpg',
                    '/portfolio/filario/20.jpg',
                    '/portfolio/filario/21.jpg',
                    '/portfolio/filario/22.jpg',
                    '/portfolio/filario/23.jpg',
                    '/portfolio/filario/24.jpg',
                    '/portfolio/filario/25.jpg',
                    '/portfolio/filario/26.jpg',
                    '/portfolio/filario/27.jpg',
                    '/portfolio/filario/28.jpg',
                    '/portfolio/filario/29.jpg',
                    '/portfolio/filario/30.jpg',
                    '/portfolio/filario/31.jpg',
                    '/portfolio/filario/32.jpg',
                    '/portfolio/filario/33.jpg',
                    '/portfolio/filario/34.jpg',
                    '/portfolio/filario/35.jpg',
                    '/portfolio/filario/36.jpg',
                    '/portfolio/filario/37.jpg',
                    '/portfolio/filario/38.jpg',
                    '/portfolio/filario/39.jpg',
                    '/portfolio/filario/40.jpg',
                    '/portfolio/filario/41.jpg',
                ],
            },
            {
                title: "Guesthouse Castagnola",
                place: "Castagnola, Lugano",
                category: "hotels",
                description: "Ein Boutique-Gästehaus in Castagnola über dem Luganersee — mediterrane Leichtigkeit, warme Zimmer und subtropische Gärten.",
                cover: '/portfolio/guesthouse-castagnola/1.jpg',
                photos: [
                    '/portfolio/guesthouse-castagnola/1.jpg',
                    '/portfolio/guesthouse-castagnola/2.jpg',
                    '/portfolio/guesthouse-castagnola/3.jpg',
                    '/portfolio/guesthouse-castagnola/4.jpg',
                    '/portfolio/guesthouse-castagnola/5.jpg',
                    '/portfolio/guesthouse-castagnola/6.jpg',
                    '/portfolio/guesthouse-castagnola/7.jpg',
                    '/portfolio/guesthouse-castagnola/8.jpg',
                    '/portfolio/guesthouse-castagnola/9.jpg',
                    '/portfolio/guesthouse-castagnola/10.jpg',
                    '/portfolio/guesthouse-castagnola/11.jpg',
                    '/portfolio/guesthouse-castagnola/12.jpg',
                    '/portfolio/guesthouse-castagnola/13.jpg',
                    '/portfolio/guesthouse-castagnola/14.jpg',
                    '/portfolio/guesthouse-castagnola/15.jpg',
                    '/portfolio/guesthouse-castagnola/16.jpg',
                    '/portfolio/guesthouse-castagnola/17.jpg',
                    '/portfolio/guesthouse-castagnola/18.jpg',
                    '/portfolio/guesthouse-castagnola/19.jpg',
                    '/portfolio/guesthouse-castagnola/20.jpg',
                    '/portfolio/guesthouse-castagnola/21.jpg',
                    '/portfolio/guesthouse-castagnola/22.jpg',
                    '/portfolio/guesthouse-castagnola/23.jpg',
                    '/portfolio/guesthouse-castagnola/24.jpg',
                ],
            },
            {
                title: "Salotto Brè",
                place: "Brè, Lugano",
                category: "hotels",
                description: "Ein charaktervoller Rückzugsort im Dorf Brè über Lugano — rustikaler Tessiner Charme und Blick über den See.",
                cover: '/portfolio/salotto-bre/1.jpg',
                photos: [
                    '/portfolio/salotto-bre/1.jpg',
                    '/portfolio/salotto-bre/2.jpg',
                    '/portfolio/salotto-bre/3.jpg',
                    '/portfolio/salotto-bre/4.jpg',
                    '/portfolio/salotto-bre/5.jpg',
                    '/portfolio/salotto-bre/6.jpg',
                    '/portfolio/salotto-bre/7.jpg',
                    '/portfolio/salotto-bre/8.jpg',
                    '/portfolio/salotto-bre/9.jpg',
                    '/portfolio/salotto-bre/10.jpg',
                    '/portfolio/salotto-bre/11.jpg',
                    '/portfolio/salotto-bre/12.jpg',
                    '/portfolio/salotto-bre/13.jpg',
                    '/portfolio/salotto-bre/14.jpg',
                    '/portfolio/salotto-bre/15.jpg',
                ],
            },
            {
                title: "Lugano",
                place: "Lugano, Schweiz",
                category: "tourism",
                description: "Content rund um Lugano und das Tessin — palmengesäumte Promenaden, mediterranes Licht und der ruhige Rhythmus der Schweizer Südseite.",
                cover: '/portfolio/lugano-tourism/1.jpg',
                photos: [
                    '/portfolio/lugano-tourism/1.jpg',
                    '/portfolio/lugano-tourism/2.jpg',
                    '/portfolio/lugano-tourism/3.jpg',
                    '/portfolio/lugano-tourism/4.jpg',
                    '/portfolio/lugano-tourism/5.jpg',
                    '/portfolio/lugano-tourism/6.jpg',
                    '/portfolio/lugano-tourism/7.jpg',
                    '/portfolio/lugano-tourism/8.jpg',
                    '/portfolio/lugano-tourism/9.jpg',
                    '/portfolio/lugano-tourism/10.jpg',
                    '/portfolio/lugano-tourism/11.jpg',
                    '/portfolio/lugano-tourism/12.jpg',
                    '/portfolio/lugano-tourism/13.jpg',
                    '/portfolio/lugano-tourism/14.jpg',
                    '/portfolio/lugano-tourism/15.jpg',
                    '/portfolio/lugano-tourism/16.jpg',
                    '/portfolio/lugano-tourism/17.jpg',
                    '/portfolio/lugano-tourism/18.jpg',
                    '/portfolio/lugano-tourism/19.jpg',
                    '/portfolio/lugano-tourism/20.jpg',
                    '/portfolio/lugano-tourism/21.jpg',
                    '/portfolio/lugano-tourism/22.jpg',
                    '/portfolio/lugano-tourism/23.jpg',
                    '/portfolio/lugano-tourism/24.jpg',
                    '/portfolio/lugano-tourism/25.jpg',
                    '/portfolio/lugano-tourism/26.jpg',
                    '/portfolio/lugano-tourism/27.jpg',
                    '/portfolio/lugano-tourism/28.jpg',
                    '/portfolio/lugano-tourism/29.jpg',
                    '/portfolio/lugano-tourism/30.jpg',
                    '/portfolio/lugano-tourism/31.jpg',
                    '/portfolio/lugano-tourism/32.jpg',
                    '/portfolio/lugano-tourism/33.jpg',
                    '/portfolio/lugano-tourism/34.jpg',
                    '/portfolio/lugano-tourism/35.jpg',
                    '/portfolio/lugano-tourism/36.jpg',
                    '/portfolio/lugano-tourism/37.jpg',
                    '/portfolio/lugano-tourism/38.jpg',
                    '/portfolio/lugano-tourism/39.jpg',
                    '/portfolio/lugano-tourism/40.jpg',
                    '/portfolio/lugano-tourism/41.jpg',
                    '/portfolio/lugano-tourism/42.jpg',
                    '/portfolio/lugano-tourism/43.jpg',
                    '/portfolio/lugano-tourism/44.jpg',
                    '/portfolio/lugano-tourism/45.jpg',
                    '/portfolio/lugano-tourism/46.jpg',
                    '/portfolio/lugano-tourism/47.jpg',
                    '/portfolio/lugano-tourism/48.jpg',
                    '/portfolio/lugano-tourism/49.jpg',
                    '/portfolio/lugano-tourism/50.jpg',
                    '/portfolio/lugano-tourism/51.jpg',
                    '/portfolio/lugano-tourism/52.jpg',
                    '/portfolio/lugano-tourism/53.jpg',
                    '/portfolio/lugano-tourism/54.jpg',
                    '/portfolio/lugano-tourism/55.jpg',
                    '/portfolio/lugano-tourism/56.jpg',
                    '/portfolio/lugano-tourism/57.jpg',
                    '/portfolio/lugano-tourism/58.jpg',
                    '/portfolio/lugano-tourism/59.jpg',
                    '/portfolio/lugano-tourism/60.jpg',
                ],
            },
            {
                title: "Eiger Lodge",
                place: "Grindelwald, Schweiz",
                category: "hotels",
                description: "Eine Boutique-Berghütte unter dem Eiger. Warme Interieurs, Bergblicke und ruhiges Morgenlicht.",
                cover: '/portfolio/eiger-lodge/1.jpg',
                photos: [
                    '/portfolio/eiger-lodge/1.jpg',
                    '/portfolio/eiger-lodge/2.jpg',
                    '/portfolio/eiger-lodge/3.jpg',
                    '/portfolio/eiger-lodge/4.jpg',
                    '/portfolio/eiger-lodge/5.jpg',
                    '/portfolio/eiger-lodge/6.jpg',
                    '/portfolio/eiger-lodge/7.jpg',
                    '/portfolio/eiger-lodge/8.jpg',
                    '/portfolio/eiger-lodge/9.jpg',
                ],
            },
            {
                title: "Giardino Lago",
                place: "Locarno, Schweiz",
                category: "hotels",
                description: "Boutique-Hotel am Lago Maggiore, Licht auf dem Wasser und Interieurs, die Ruhe ausstrahlen.",
                cover: '/portfolio/giardino-lago/15.jpg',
                photos: [
                    '/portfolio/giardino-lago/1.jpg',
                    '/portfolio/giardino-lago/2.jpg',
                    '/portfolio/giardino-lago/3.jpg',
                    '/portfolio/giardino-lago/4.jpg',
                    '/portfolio/giardino-lago/5.jpg',
                    '/portfolio/giardino-lago/6.jpg',
                    '/portfolio/giardino-lago/7.jpg',
                    '/portfolio/giardino-lago/8.jpg',
                    '/portfolio/giardino-lago/9.jpg',
                    '/portfolio/giardino-lago/10.jpg',
                    '/portfolio/giardino-lago/11.jpg',
                    '/portfolio/giardino-lago/12.jpg',
                    '/portfolio/giardino-lago/13.jpg',
                    '/portfolio/giardino-lago/14.jpg',
                    '/portfolio/giardino-lago/15.jpg',
                    '/portfolio/giardino-lago/16.jpg',
                ],
            },
            {
                title: "Giardino Ascona",
                place: "Ascona, Schweiz",
                category: "hotels",
                description: "Klassisches Ascona, Patios mit Olivenbäumen, mediterrane Details und langsame Nachmittage.",
                cover: '/portfolio/giardino-ascona/1.jpg',
                photos: [
                    '/portfolio/giardino-ascona/1.jpg',
                    '/portfolio/giardino-ascona/2.jpg',
                    '/portfolio/giardino-ascona/3.jpg',
                    '/portfolio/giardino-ascona/4.jpg',
                    '/portfolio/giardino-ascona/5.jpg',
                    '/portfolio/giardino-ascona/6.jpg',
                    '/portfolio/giardino-ascona/7.jpg',
                    '/portfolio/giardino-ascona/8.jpg',
                    '/portfolio/giardino-ascona/9.jpg',
                    '/portfolio/giardino-ascona/10.jpg',
                    '/portfolio/giardino-ascona/11.jpg',
                    '/portfolio/giardino-ascona/12.jpg',
                    '/portfolio/giardino-ascona/13.jpg',
                ],
            },
            {
                title: "Luzern",
                place: "Schweiz",
                category: "tourism",
                description: "Luzern im Sommerlicht, der See, die Holzbrücken und die Alpen direkt dahinter.",
                cover: '/portfolio/lucerne/1.jpg',
                photos: [
                    '/portfolio/lucerne/1.jpg',
                    '/portfolio/lucerne/2.jpg',
                    '/portfolio/lucerne/3.jpg',
                    '/portfolio/lucerne/4.jpg',
                    '/portfolio/lucerne/5.jpg',
                    '/portfolio/lucerne/6.jpg',
                    '/portfolio/lucerne/7.jpg',
                    '/portfolio/lucerne/8.jpg',
                ],
            },
            {
                title: "Kulturhof Hinter Musegg",
                place: "Luzern, Schweiz",
                category: "tourism",
                description: "Shooting im historischen Kulturhof Hinter Musegg, Atmosphäre, Details und natürliches Licht.",
                cover: '/portfolio/kulturhof/1.jpg',
                photos: [
                    '/portfolio/kulturhof/1.jpg',
                    '/portfolio/kulturhof/2.jpg',
                    '/portfolio/kulturhof/3.jpg',
                    '/portfolio/kulturhof/4.jpg',
                    '/portfolio/kulturhof/5.jpg',
                    '/portfolio/kulturhof/6.jpg',
                    '/portfolio/kulturhof/7.jpg',
                    '/portfolio/kulturhof/8.jpg',
                    '/portfolio/kulturhof/9.jpg',
                    '/portfolio/kulturhof/10.jpg',
                    '/portfolio/kulturhof/11.jpg',
                    '/portfolio/kulturhof/12.jpg',
                ],
            },
            {
                title: "Ascona",
                place: "Tessin, Schweiz",
                category: "tourism",
                description: "Die Altstadt von Ascona am Lago Maggiore, Pastelltöne und der Geschmack eines Tessiner Sommers.",
                cover: '/portfolio/ascona/1.jpg',
                photos: [
                    '/portfolio/ascona/1.jpg',
                    '/portfolio/ascona/2.jpg',
                    '/portfolio/ascona/3.jpg',
                    '/portfolio/ascona/4.jpg',
                    '/portfolio/ascona/5.jpg',
                    '/portfolio/ascona/6.jpg',
                    '/portfolio/ascona/7.jpg',
                    '/portfolio/ascona/8.jpg',
                    '/portfolio/ascona/9.jpg',
                    '/portfolio/ascona/10.jpg',
                    '/portfolio/ascona/11.jpg',
                    '/portfolio/ascona/12.jpg',
                ],
            },
            {
                title: "Locarno",
                place: "Tessin, Schweiz",
                category: "tourism",
                description: "Locarno im Sommerlicht, Piazza Grande, der See und die Stimmung des Südens der Schweiz.",
                cover: '/portfolio/locarno/1.jpg',
                photos: [
                    '/portfolio/locarno/1.jpg',
                    '/portfolio/locarno/2.jpg',
                    '/portfolio/locarno/3.jpg',
                    '/portfolio/locarno/4.jpg',
                    '/portfolio/locarno/5.jpg',
                    '/portfolio/locarno/6.jpg',
                    '/portfolio/locarno/7.jpg',
                    '/portfolio/locarno/8.jpg',
                ],
            },
            {
                title: "Jungfraujoch",
                place: "Berner Oberland",
                category: "tourism",
                description: "Top of Europe. Gletscher, Eistunnel und die weisse Stille über den Wolken.",
                cover: '/portfolio/jungfraujoch/1.jpg',
                photos: [
                    '/portfolio/jungfraujoch/1.jpg',
                    '/portfolio/jungfraujoch/2.jpg',
                    '/portfolio/jungfraujoch/3.jpg',
                    '/portfolio/jungfraujoch/4.jpg',
                    '/portfolio/jungfraujoch/5.jpg',
                    '/portfolio/jungfraujoch/6.jpg',
                    '/portfolio/jungfraujoch/7.jpg',
                    '/portfolio/jungfraujoch/8.jpg',
                    '/portfolio/jungfraujoch/9.jpg',
                ],
            },
            {
                title: "Harder Kulm",
                place: "Berner Oberland",
                category: "tourism",
                description: "Aussichtspunkt über Interlaken, Panorama auf Eiger, Mönch und Jungfrau.",
                cover: '/portfolio/harder-kulm/1.jpg',
                photos: [
                    '/portfolio/harder-kulm/1.jpg',
                    '/portfolio/harder-kulm/2.jpg',
                    '/portfolio/harder-kulm/3.jpg',
                    '/portfolio/harder-kulm/4.jpg',
                    '/portfolio/harder-kulm/5.jpg',
                    '/portfolio/harder-kulm/6.jpg',
                    '/portfolio/harder-kulm/7.jpg',
                    '/portfolio/harder-kulm/8.jpg',
                ],
            },
            {
                title: "Grindelwald First",
                place: "Berner Oberland",
                category: "tourism",
                description: "In den Berner Alpen, Wanderwege, Bahn und Aussichten, die einen innehalten lassen.",
                cover: '/portfolio/grindelwald-first/1.jpg',
                photos: [
                    '/portfolio/grindelwald-first/1.jpg',
                    '/portfolio/grindelwald-first/2.jpg',
                    '/portfolio/grindelwald-first/3.jpg',
                    '/portfolio/grindelwald-first/4.jpg',
                ],
            },
            {
                title: "Bern",
                place: "Schweiz",
                category: "tourism",
                description: "Die Schweizer Hauptstadt im Herbstlicht, Lauben, die Aare und stimmungsvolle Gassen.",
                cover: '/portfolio/bern/1.jpg',
                photos: [
                    '/portfolio/bern/1.jpg',
                    '/portfolio/bern/2.jpg',
                    '/portfolio/bern/3.jpg',
                    '/portfolio/bern/4.jpg',
                    '/portfolio/bern/5.jpg',
                    '/portfolio/bern/6.jpg',
                    '/portfolio/bern/7.jpg',
                    '/portfolio/bern/8.jpg',
                    '/portfolio/bern/9.jpg',
                    '/portfolio/bern/10.jpg',
                    '/portfolio/bern/11.jpg',
                    '/portfolio/bern/12.jpg',
                ],
            },
            {
                title: "Algarve",
                place: "Portugal",
                category: "tourism",
                description: "Klippen, Ozean und das Licht der Algarve-Küste, wie eine Postkarte gerahmt.",
                cover: '/portfolio/algarve/1.jpg',
                photos: [
                    '/portfolio/algarve/1.jpg',
                    '/portfolio/algarve/2.jpg',
                    '/portfolio/algarve/3.jpg',
                    '/portfolio/algarve/4.jpg',
                    '/portfolio/algarve/5.jpg',
                    '/portfolio/algarve/6.jpg',
                    '/portfolio/algarve/7.jpg',
                    '/portfolio/algarve/8.jpg',
                ],
            },
            {
                title: "Veoli Botanica",
                place: "Produktshooting",
                category: "products",
                description: "Shooting für die polnische Botanik-Beauty-Marke Veoli, natürliche Palette und klare Bilder.",
                cover: '/portfolio/veoli-botanica/1.jpg',
                photos: [
                    '/portfolio/veoli-botanica/1.jpg',
                    '/portfolio/veoli-botanica/2.jpg',
                    '/portfolio/veoli-botanica/3.jpg',
                    '/portfolio/veoli-botanica/4.jpg',
                    '/portfolio/veoli-botanica/5.jpg',
                    '/portfolio/veoli-botanica/6.jpg',
                    '/portfolio/veoli-botanica/7.jpg',
                    '/portfolio/veoli-botanica/8.jpg',
                ],
            },
            {
                title: "Emu",
                place: "Produktshooting",
                category: "products",
                description: "Produktshooting für Emu. Klares Licht, warme Töne und Bilder, die das Produkt sprechen lassen.",
                cover: '/portfolio/emu/1.jpg',
                photos: [
                    '/portfolio/emu/1.jpg',
                    '/portfolio/emu/2.jpg',
                    '/portfolio/emu/3.jpg',
                    '/portfolio/emu/4.jpg',
                    '/portfolio/emu/5.jpg',
                    '/portfolio/emu/6.jpg',
                    '/portfolio/emu/7.jpg',
                    '/portfolio/emu/8.jpg',
                    '/portfolio/emu/9.jpg',
                    '/portfolio/emu/10.jpg',
                    '/portfolio/emu/11.jpg',
                ],
            },
            {
                title: "So Bloomy",
                place: "Produktshooting",
                category: "products",
                description: "Produktshooting für So Bloomy. Herbstpalette, warmes Licht und Bilder, die eine Markenstimmung erzeugen.",
                cover: '/portfolio/autumn-product/6.jpg',
                photos: [
                    '/portfolio/autumn-product/1.jpg',
                    '/portfolio/autumn-product/2.jpg',
                    '/portfolio/autumn-product/3.jpg',
                    '/portfolio/autumn-product/4.jpg',
                    '/portfolio/autumn-product/5.jpg',
                    '/portfolio/autumn-product/6.jpg',
                    '/portfolio/autumn-product/7.jpg',
                    '/portfolio/autumn-product/8.jpg',
                ],
            },
            {
                title: "Dilmah",
                place: "Produktshooting",
                category: "products",
                description: "Weihnachts-Produktshooting für Dilmah. Warmes Licht, Atmosphäre und Details für Hospitality- und Lifestyle-Marken.",
                cover: '/portfolio/christmas/2.jpg',
                photos: [
                    '/portfolio/christmas/1.jpg',
                    '/portfolio/christmas/2.jpg',
                    '/portfolio/christmas/3.jpg',
                    '/portfolio/christmas/4.jpg',
                    '/portfolio/christmas/5.jpg',
                    '/portfolio/christmas/6.jpg',
                    '/portfolio/christmas/7.jpg',
                    '/portfolio/christmas/8.jpg',
                ],
            },
            {
                title: "Big Active",
                place: "Produktshooting",
                category: "products",
                description: "Shooting für Big Active. Tee in warmer Komposition, Stimmung direkt aus dem Blatt.",
                cover: '/portfolio/tea-product/1.jpg',
                photos: [
                    '/portfolio/tea-product/1.jpg',
                    '/portfolio/tea-product/2.jpg',
                    '/portfolio/tea-product/3.jpg',
                    '/portfolio/tea-product/4.jpg',
                    '/portfolio/tea-product/5.jpg',
                    '/portfolio/tea-product/6.jpg',
                    '/portfolio/tea-product/7.jpg',
                    '/portfolio/tea-product/8.jpg',
                ],
            },
        ],
    },
    brands: {
        label: 'MIT WEM ICH GEARBEITET HABE',
        items: [
            { name: 'Jungfrau Region' },
            { name: 'Taksidi' },
            { name: 'Canon' },
            { name: 'Lucerne Tourism' },
            { name: 'Titlis' },
            { name: 'Grindelwald First' },
            { name: 'Jungfraujoch' },
            { name: 'Eiger Lodge' },
            { name: 'Adelboden-Lenk-Kandersteg' },
            { name: 'Zentralbahn' },
            { name: 'Lake Lucerne' },
            { name: 'Tara Style' },
            { name: 'Dilmah' },
            { name: 'Everest Outdoor' },
            { name: 'Emu Australia' },
            { name: 'Krups' },
        ],
    },
    faq: {
        label: "FAQ",
        title: "Häufig gestellte Fragen.",
        items: [
            { q: "Was kostet ein Content-Shoot in der Schweiz?",
                a: "Der Preis hängt vollständig vom Umfang und der Komplexität des Projekts ab: ein einzelnes Foto-Set, ein komplettes Reel-Paket oder das End-to-End Social Media Management werden unterschiedlich kalkuliert. Jedes Angebot baue ich auf das auf, was die Marke wirklich braucht, deshalb erstelle ich gerne ein massgeschneidertes Angebot für dich." },
            { q: "Was ist in einem Content-Creation-Paket enthalten?",
                a: "Die meisten Projekte umfassen den gesamten kreativen Prozess: Mood-Planung und Konzept, Fotografie, Short-Form-Video wo es passt, Editing und finale Dateien, die du auf deinen eigenen Kanälen nutzen kannst. Je nach Paket können wir den Beitrag auch auf {'@'}travellingdominika gemeinsam veröffentlichen." },
            { q: "Reist du für Shootings?",
                a: "Ja, überall in der Schweiz, und ich nehme auch Projekte in anderen Ländern an. Reisekosten für weiter entfernte Orte sind im Angebot transparent ausgewiesen." },
            { q: "Was ist der Unterschied zwischen Content Creation und Social Media Management?",
                a: "Content Creation bedeutet, dass ich die Fotos, Reels und Storytelling-Inhalte erstelle und du sie auf deinen eigenen Kanälen postest. Social Media Management heisst, dass ich deine Profile ganzheitlich übernehme: Planung, Posts, Captions, Antworten auf Nachrichten, alles auf Instagram, Facebook, LinkedIn oder TikTok." },
            { q: "Wie lange dauert ein Hotel- oder Restaurant-Shooting?",
                a: "Ein fokussierter halber Tag vor Ort reicht für die meisten Boutique-Hotels und Restaurants. Grössere Objekte oder Shootings mit vielen Deliverables dauern in der Regel einen ganzen Tag oder zwei. Editing und Lieferung folgen innerhalb von ein bis zwei Wochen." },
            { q: "Kann ich die Fotos und Reels auf meinen eigenen Kanälen nutzen?",
                a: "Ja. Foto- und Reel-Pakete kommen mit Nutzungsrechten für deine Marken-Kanäle, Website und Marketingmaterialien. Spezifische Exklusivität oder Paid-Media-Nutzung wird im Voraus geregelt." },
            { q: "Produzierst du auch Short-Form-Video, Reels und TikTok-Content?",
                a: "Ja, Short-Form-Video ist ein zentraler Teil meiner Arbeit. Reel-Pakete enthalten 30 bis 45 Sekunden Material, und ich kann auch einen wiederkehrenden Rhythmus von wöchentlichen oder monatlichen Reels parallel zur Fotografie aufbauen." },
            { q: "Arbeitest du auch mit Restaurants, Tourismusregionen und Produktmarken?",
                a: "Ja. Der grösste Teil meiner Arbeit ist im Hotel- und Hospitality-Bereich, aber ich erstelle auch Content für Tourismusregionen, Restaurants und Cafés, lokale Unternehmen und Produktmarken. Zu den letzten Produktkunden gehören Veoli Botanica, So Bloomy, Dilmah und Big Active." },
            { q: "Wie viel Vorlauf sollte ich für eine Buchung einplanen?",
                a: "Zwei bis vier Wochen Vorlauf sind ideal, damit wir Mood, Location und Timing in Ruhe planen können. In der Hochsaison wie Sommer im Tessin oder Winter im Berner Oberland lohnt es sich, noch früher zu buchen." },
        ],
    },
    seo: {
        home: {
            title: "Hotel- und Tourismus-Content-Creatorin in der Schweiz",
            description: "Ich bin Dominika, Content Creatorin und Fotografin in der Schweiz. Ich arbeite mit Hotels, Tourismus und Marken. Fotografie, Reels, Social Media.",
        },
        portfolio: {
            title: "Portfolio · Hotel-, Tourismus- und Produktfotografie in der Schweiz",
            description: "Ausgewählte Foto- und Content-Arbeiten aus der ganzen Schweiz: Hotels, Tourismus und Produkt-Brand-Sessions.",
        },
        hotels: {
            title: "Hotel Content Creator Schweiz · Portfolio",
            description: "Hotel-Shootings und Partnerschaften in der ganzen Schweiz. Boutique-Hospitality-Fotografie von Dominika.",
        },
        tourism: {
            title: "Tourismus- und Reisefotografie in der Schweiz · Portfolio",
            description: "Tourismus-, Reise- und Destination-Content aus der ganzen Schweiz: Tessin, Luzern, Berner Oberland und mehr.",
        },
        products: {
            title: "Produktfotografie und Brand-Content · Portfolio",
            description: "Produktshootings für Skincare-, Food- und Lifestyle-Marken. Aktuelle Kunden: Veoli Botanica, So Bloomy, Dilmah und Big Active.",
        },
        privacy: {
            title: "Datenschutzerklärung",
            description: "Wie travellingdominika.com mit deinen Daten umgeht: keine Cookies, kein Tracking, keine Analyse.",
        },
    },
    contact: {
        label: 'KONTAKT',
        title: 'Lass uns herausfinden, was ich für dich tun kann.',
        sub: 'Schreib mir, ich freue mich auf jede Nachricht.',
        email: "dominikatrunowicz{'@'}gmail.com",
        cta: 'Schreib mir',
    },
    privacy: {
        label: 'DATENSCHUTZ',
        title: 'Datenschutzerklärung',
        updated: 'Zuletzt aktualisiert: Juni 2026',
        intro: 'Diese Seite ist mein persönliches Portfolio. Ich halte sie einfach und erhebe so wenig wie möglich — hier steht, was das konkret bedeutet.',
        sections: [
            {
                heading: 'Keine Cookies, kein Tracking',
                body: 'travellingdominika.com verwendet keine Cookies, keine Analyse und kein Tracking durch Dritte. Über deinen Besuch wird nichts gespeichert oder profiliert.',
            },
            {
                heading: 'Hosting',
                body: 'Die Seite wird als statische Dateien über Cloudflare ausgeliefert, das grundlegende technische Anfragedaten (etwa deine IP-Adresse) verarbeiten kann, um Seiten bereitzustellen und Missbrauch zu verhindern. Details findest du in der Datenschutzerklärung von Cloudflare.',
            },
            {
                heading: 'Kontakt per E-Mail',
                body: 'Wenn du mir schreibst, verwende ich deine Nachricht und Adresse nur, um dir zu antworten. Ich setze dich auf keine Liste und gebe deine Daten an niemanden weiter.',
            },
            {
                heading: 'Social-Media-Links',
                body: 'Links zu Instagram und LinkedIn führen dich zu diesen Plattformen, die eigene Datenschutzerklärungen haben.',
            },
            {
                heading: 'Fragen',
                body: 'Fragen zu deinen Daten? Schreib mir einfach:',
            },
        ],
    },
    footer: {
        contactLabel: 'KONTAKT',
        email: "dominikatrunowicz{'@'}gmail.com",
        responseTime: 'Antwort innerhalb von 24 h.',
        socialLabel: 'SOCIAL',
        instagramLabel: 'Instagram',
        instagramUrl: 'https://instagram.com/travellingdominika',
        linkedinLabel: 'LinkedIn',
        linkedinUrl: 'https://www.linkedin.com/in/dominika-trunowicz-317403274/',
        copyright: '© 2026 travellingdominika',
        privacy: 'Datenschutz',
        privacyUrl: '#privacy',
    },
};
